import { AlertTriangle } from 'lucide-react';
import type { JSX } from 'react';

import type { DeviationResult } from '../../../orders/api';

export interface DeviationAlertBadgeProps {
  deviation: DeviationResult | null;
}

/**
 * `day-board/spec.md` → "Indicador visual de alerta de desvío". Reads
 * `deviation` straight from the `GET /orders/day-status` row — this
 * endpoint already embeds it per entry (`GetDayStatusUseCase`, PR 3), so
 * there is no per-row `GET /orders/:id/deviation` call to make; that
 * endpoint backs `OrderDetailPage`'s own comparison instead.
 */
export function DeviationAlertBadge({ deviation }: DeviationAlertBadgeProps): JSX.Element | null {
  if (deviation === null || !deviation.isDeviating) {
    return null;
  }

  const percent =
    deviation.deviationRatio === null ? null : Math.round(deviation.deviationRatio * 100);

  return (
    <span className="inline-flex items-center gap-1 text-xs font-medium text-amber-700">
      <AlertTriangle aria-hidden="true" className="size-3.5" />
      Desvío{percent === null ? '' : ` ${percent}%`}
    </span>
  );
}
